/* eslint-disable
    func-names,
    max-len,
    no-cond-assign,
    radix,
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS104: Avoid inline assignments
 * DS204: Change includes calls to have a more natural evaluation order
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
const _ = require('lodash');
const { parse, format } = require('date-fns');

const CategorizerTableCtrl = function (
  $scope,
  $filter,
  $state,
  CategorizerRuleCollection,
  CategorizerRule,
  LedgerCollection,
  NotificationsService,
) {
  this.rules = new CategorizerRuleCollection(this.clientId);
  this.ledgers = new LedgerCollection(this.clientId);
  this.selectedRuleIds = [];
  this.resultsPerPage = 20;
  this.toggleSelectEnabled = false;
  this.orderByField = 'createdOn';
  this.sortOrder = -1;

  this.checkCurrentRules = function () {
    if (this.rules.pattern !== this.currentPattern) {
      this.selectedPage = 1;
    }

    return this.setCurrentRules();
  };

  this.sortBy = function (property) {
    this.sortOrder = property === this.orderByField ? this.sortOrder * -1 : 1;
    this.orderByField = property;
    this.checkCurrentRules(); // will trigger a sort to happen
  };

  this.setCurrentRules = function (page = this.selectedPage) {
    const { data, pattern } = this.rules;
    const property = this.orderByField;
    const sortOrder = this.sortOrder;
    const properties = property.split('.');

    // sort the data prior to doing pagination filtering
    const sortedData = data.sort((a, b) => {
      let propA = properties.length == 1 ? a[property] : a[properties[0]]()[properties[1]]; // a[$ledger] is a function
      let propB = properties.length == 1 ? b[property] : b[properties[0]]()[properties[1]];
      if (property === 'createdBy') {
        if (!propA) propA = 'AA';
        if (!propB) propB = 'AA';
      }
      if (propA && (typeof propA === 'string' || propA instanceof String))
        propA = propA.toLowerCase();
      if (propB && (typeof propB === 'string' || propB instanceof String))
        propB = propB.toLowerCase();
      let result = 0;
      if (propA < propB) result = -1;
      if (propA > propB) result = 1;
      return result * sortOrder;
    });

    const start = (page - 1) * this.resultsPerPage;
    const end = page * this.resultsPerPage;

    const filtered = $filter('filter')(sortedData, pattern);
    this.totalResults = filtered.length;
    this.currentPattern = pattern;
    filtered.map(rule => {
      rule.createdOn = format(parse(rule.createdOn), 'YYYY-MM-DD');
      return rule;
    });
    return (this.currentRules = filtered.slice(start, end));
  };

  this.rules.$onSet(() => {
    this.selectedPage = 1;
    this.totalResults = this.rules.data.length;
    return this.checkCurrentRules();
  });

  $scope.$watch('vm.rules.pattern', () => this.checkCurrentRules());

  this.changePage = function () {
    return this.checkCurrentRules();
  };

  this.nullStateConfig = {
    icon: 'bl-icon-smiley-envelope',
    header: 'Your categorizer rule list is clean',
    body: "Why don't you upload some now?",
  };

  this.emptyStateConfig = {
    icon: 'bl-icon-search',
    header: () => {
      if (this.rules.pattern != null) {
        return `We couldn't find any rules for ${this.rules.pattern}`;
      }
    },
    body: 'Maybe try a different query?',
  };

  this.hasSelected = () => this.selectedRuleIds.length > 0;

  this.toggleRule = function (ruleId) {
    const currentRuleId = parseInt(this.ruleId);

    if (currentRuleId === ruleId) {
      return $state.go('^');
    }
    return $state.go('bench.categorizer.rule', { ruleId });
  };

  this.delete = () => {
    const deletePromise = this.isAllRulesSelected()
      ? this.rules.$delete()
      : this.rules.$delete(this.selectedRuleIds);
    const numRules = this.getNumberRulesSelected();

    if (window.heap) {
      if (this.isAllRulesSelected()) {
        window.heap.track('Client Rule Deleted All', {
          ruleIds: JSON.stringify(this.selectedRuleIds),
          numOfRulesDeleted: this.selectedRuleIds?.length.toString(),
          deleteAt: new Date().toString(),
          action: 'Client Rule Deleted All',
        });
      } else {
        this.selectedRuleIds?.forEach(id => {
          window.heap.track('Client Rule Deleted', {
            ruleId: JSON.stringify(id),
            deleteAt: new Date().toString(),
            ruleDeleted: JSON.stringify(this.currentRules?.filter(rule => rule.id === id)),
            action: 'Client Rule Deleted',
          });
        });
      }
    }

    return NotificationsService.loader({
      resolve: deletePromise,
      loadingText: `Deleting rule${[numRules !== 1 ? 's' : undefined]}...`,
      successText: `${numRules} rule${[numRules !== 1 ? 's' : undefined]} sucessfully deleted!`,
      failureText: 'Rule deletion failed.',
    }).then(() => {
      // exit details view if focused rule is deleted
      let needle;
      if (((needle = parseInt(this.ruleId)), this.selectedRuleIds.includes(needle))) {
        $state.go('^');
      }

      this.selectedRuleIds = [];
      return this.rules.$fetch();
    });
  };

  this.onCheck = rule => {
    if (!this.isSelected(rule)) {
      return this.selectedRuleIds.push(rule.id);
    }
    return (this.selectedRuleIds = _.without(this.selectedRuleIds, rule.id));
  };

  this.toggleSelectAll = () => {
    if (!this.isRulesSelected()) {
      // or @isAllRulesSelected()
      this.selectedRuleIds = this.getIds();
      return (this.toggleSelectEnabled = true);
    }
    this.selectedRuleIds = [];
    return (this.toggleSelectEnabled = false);
  };

  this.isAllRulesSelected = function () {
    return this.selectedRuleIds.length === this.rules.data.length;
  };

  this.isRulesSelected = function () {
    return (this.selectedRuleIds != null ? this.selectedRuleIds.length : undefined) > 0;
  };

  this.getIds = function () {
    return this.currentRules.map(i => i.id);
  };

  this.isSelected = function (rule) {
    const ruleId = rule.id;

    return this.selectedRuleIds.includes(ruleId);
  };

  this.getNumberRulesSelected = () => {
    if (this.isAllRulesSelected()) {
      return 'All';
    }
    return this.selectedRuleIds.length;
  };

  this.getDeleteConfirmMessage = () => {
    const numRules = this.getNumberRulesSelected();

    return `${numRules} rule${[
      numRules !== 1 ? 's' : undefined,
    ]} will be deleted. Are you sure about this?`;
  };
};

module.exports = CategorizerTableCtrl;
